import React from 'react';
import PropTypes from 'prop-types';
import CSVReader from 'react-csv-reader';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import CancelButton from '../Buttons/CancelButton';
import CreateButton from '../Buttons/CreateButton';

const CSVUploadDialog = (props) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onRequestClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">CSV Upload</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Click on the button to open a CSV file.
        </DialogContentText>
        <CreateButton
          variant="outlined"
          size="large"
        >
          <CSVReader
            cssClass="react-csv-input"
            onFileLoaded={props.onFileLoaded}
          />
        </CreateButton>
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={props.onRequestClose}
          variant="outlined"
          size="large"
        >
          Cancel
        </CancelButton>
      </DialogActions>
    </Dialog>
  );
};

CSVUploadDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onFileLoaded: PropTypes.instanceOf(Function).isRequired,
  onRequestClose: PropTypes.instanceOf(Function).isRequired,
};

export default CSVUploadDialog;
